//Snackbar action-types
export const SNACKBAR_OPEN = 'SNO';
export const SNACKBAR_CLOSE = 'SNC';

//Loader
export const IS_LOADING = 'ISL';
export const NOT_LOADING = 'NL';
